import {useEffect, useRef, useState} from 'react';
import {Button, Dialog, Portal} from '@chakra-ui/react';
import {PlazmaCopiesOption} from './PlazmaCopiesOption';

interface ConfirmDeleteDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (alsoRemovePlazmaCopies: boolean) => void;
    count: number;
    isDeleting?: boolean;
    /** Number of the files to delete that also have a plazma copy; shows the plazma option when > 0. */
    plazmaStarredCount?: number;
    /** The user may not delete those plazma copies, so removing them can't be chosen. */
    plazmaCopiesForbidden?: boolean;
}

export function ConfirmDeleteDialog({
    isOpen,
    onClose,
    onConfirm,
    count,
    isDeleting,
    plazmaStarredCount = 0,
    plazmaCopiesForbidden = false,
}: ConfirmDeleteDialogProps) {
    const cancelRef = useRef<HTMLButtonElement>(null);
    const [removePlazmaCopies, setRemovePlazmaCopies] = useState(false);

    // Default to leaving plazma copies alone every time the dialog opens.
    useEffect(() => {
        if (isOpen) setRemovePlazmaCopies(false);
    }, [isOpen]);

    return <Dialog.Root
        role="alertdialog"
        open={isOpen}
        onOpenChange={(e) => {
            if (!e.open) onClose();
        }}
        initialFocusEl={() => cancelRef.current}
    >
        <Portal>
            <Dialog.Backdrop/>
            <Dialog.Positioner>
            <Dialog.Content>
                <Dialog.Header><Dialog.Title>Törlöd {count > 1 ? `ezt a ${count} fájlt` : 'a fájlt'}?</Dialog.Title></Dialog.Header>
                <Dialog.Body>
                    Ez véglegesen törli {count > 1 ? 'ezeket a fájlokat' : 'ezt a fájlt'} a Google Drive-ból.
                    A művelet nem vonható vissza.
                    {plazmaStarredCount > 0 &&
                        <PlazmaCopiesOption
                            fileCount={count}
                            starredCount={plazmaStarredCount}
                            action="remove"
                            checked={removePlazmaCopies}
                            onChange={setRemovePlazmaCopies}
                            removeForbidden={plazmaCopiesForbidden}
                        />
                    }
                </Dialog.Body>
                <Dialog.Footer gap={0}>
                    <Button ref={cancelRef} variant="subtle" onClick={onClose}>Mégse</Button>
                    <Button
                        colorPalette="red"
                        onClick={() => onConfirm(plazmaStarredCount > 0 && removePlazmaCopies && !plazmaCopiesForbidden)}
                        ml={3}
                        loading={isDeleting}
                    >
                        Törlés
                    </Button>
                </Dialog.Footer>
            </Dialog.Content>
            </Dialog.Positioner>
        </Portal>
    </Dialog.Root>;
}
